/* eslint-disable jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events */
import { productImageByFormat } from '@/utils/Common/ProductImage';
import EVENTS from '@/utils/Constants/Events';
import CONST from '@/utils/Constants/General';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CartVatRow from './CartVatRow';
import PriceBox from './OrderProductBox/PriceBox';

const BundleCartItem = ({ bundle }) => {
  const { t } = useTranslation();
  const removeItem = () => {
    DLG.EVE.emit(EVENTS.CART.BUNDLE.DELETE, {
      entryGroupNumber: bundle.entryGroupNumber,
      successMessage: t('cart:cart.entry.removed.success'),
    });
  };
  return (
    <div className='dln-cartItem__bundleWrapper'>
      <div className='dln-cartItem__bundleHeader'>
        <h3>{bundle.name}</h3>
        <div className='dln-cartItem__price x-cart-item'>
          <div>
            <div className='priceBox'>
              <PriceBox
                actualPrice={bundle.price.formattedValue}
                actualPriceValue={bundle.price.value}
                oldPrice={bundle.oldPrice.formattedValue}
                oldPriceValue={bundle.oldPrice.value}
              />
              {bundle.discountedPrice?.value > 0 && (
                <div className='discountedPrice'>
                  -&nbsp;{bundle.discountedPrice.formattedValue}
                </div>
              )}
            </div>
          </div>
        </div>
        <button
          type='button'
          className='dln-icn dln-icn--iconfont'
          onClick={removeItem}
        >
          X
        </button>
      </div>
      {bundle.products.map(product => {
        const productImage = productImageByFormat(
          product.images,
          CONST.PRODUCT.IMAGE.FORMAT.THUMBNAIL,
        );
        return (
          <div key={product.code} className='dln-cartItem x-cart'>
            <div className='dln-cartItem__content'>
              <div className='dln-cartItem__article'>
                <picture className='dln-image dln-cartItem__picture'>
                  <source
                    media='(min-width: 1200px)'
                    srcSet={productImage?.l?.url}
                  />
                  <source
                    media='(min-width: 600px) and (max-width: 1199px)'
                    srcSet={productImage?.m?.url}
                  />
                  <img
                    className='dln-image__image'
                    src={productImage?.s?.url}
                    alt={productImage?.altText}
                  />
                </picture>
                <div className='dln-cartItem__description'>
                  <div className='dln-cartItem__titleWrapper'>
                    <h3 className='dln-cartItem__title'>{product.name}</h3>
                    <div className='dln-cartItem__topCta' />
                  </div>

                  <div className='dln-cartItem__price x-cart-item'>
                    <div>
                      <div className='priceBox'>
                        <PriceBox
                          actualPrice={product.price.formattedValue}
                          actualPriceValue={product.price.value}
                        />
                        <CartVatRow
                          vat={product.vat}
                          vatRatio={product.vatratio}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

BundleCartItem.propTypes = {
  bundle: PropTypes.shape().isRequired,
};

export default BundleCartItem;
